__webpack_require__.p = "/interactive/aws-intel/2022/";